import { ProjectOptionDefVO, ProjectOptionVO, ProjectVO } from '../../../model/vo/project.vo';
import { ProjectUtils } from '../../project/util/project-utils';
import { InitManager } from '@shared/manager/init.manager';
import { AlertButton } from '@shared/alert/alertButton';
import { StringUtils } from '@shared/util/string-utils';
import { FileUtils } from '@shared/util/file-utils';
import { AlertHelper } from '@shared/alert/alert.helper';
import { ProjectExportDataService } from './project-export-data.service';
import { ProjectModel } from '../../../model/project.model';
import { CarrierBlockManager } from '../../article/manager/carrier-block.manager';
import { ApplicationService } from '@shared/application/application.service';
import { ProjectOptionUtils } from '../../project/util/project-option.utils';
import { Injectable } from '@angular/core';
import { RepresentationService } from '../../../service/representation.service';
import { ProjectService } from './project.service';
import { ProjectComponentPresenter } from '../../project-component.presenter';
import { ProjectUserModel } from '../../../model/project-user.model';
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WspProjectExportService {

  constructor(
    private alertHelper: AlertHelper,
    private projectExportDataService: ProjectExportDataService,
    private projectModel: ProjectModel,
    private representationService: RepresentationService,
    private carrierBlockManager: CarrierBlockManager,
    private applicationService: ApplicationService,
    private projectService: ProjectService,
    private projectComponentPresenter: ProjectComponentPresenter,
    private projectUserModel: ProjectUserModel,
  ) {}

  public async exportProject(): Promise<void> {
    const success = await this.interceptExportProjectEvent();
    if (success) {
      this.continueExportWSP();
    }
  }

  private async interceptExportProjectEvent(): Promise<boolean> {
    if (this.isAllRequiredOptionsFilled()) {
      return true;
    } else {

      const result = await this.alertHelper.showAlert('main.title.fill_project_options', 'main.message.fill_project_options',
        {}, [AlertButton.YES, AlertButton.NO], "help");

      if (result == AlertButton.YES) {
        this.projectComponentPresenter.openEditConfigurationSettingsComponent({
          projectNameEditable: false,
          saveAndFinalizeProject: false
        })
        return true;
      }
      return false;
    }
  }

  private isAllRequiredOptionsFilled(): boolean {
    const userOptions: ProjectOptionDefVO[] = this.projectUserModel.projectOptionDefs;
    const projectOptions: ProjectOptionVO[] = this.projectModel.currentProject.options;
    for (const projectOptionDef of userOptions) {
      if (!projectOptionDef.isRequired) {
        continue;
      }
      const correspondingOption: ProjectOptionVO = ProjectOptionUtils.findProjectOptionByIdentifier(projectOptions, projectOptionDef.identifier);
      if (!correspondingOption || !correspondingOption.value) {
        return false;
      }
    }
    return true;
  }

  private continueExportWSP(): void {
    const currentProject: ProjectVO = this.projectModel.currentProject;
    ProjectUtils.updateRotationInfoForExistingProject(currentProject);
    currentProject.infoProperties.setString("savedInConfiguratorVersion", this.applicationService.applicationVersion);
    currentProject.infoProperties.setString("projectOptionDataVersion", InitManager.PROJECT_OPTION_DATA_VERSION);
    this.representationService.update();
    this.carrierBlockManager.updateCarrierBlocksInProject(currentProject);
    lastValueFrom(this.projectExportDataService.exportWSPProject(currentProject))
      .then(data => {
        this.alertHelper.showAlert('main.title.export_project_finished', 'main.message.export_project_finished', {}, [AlertButton.OK],
          "info").then(() => {
          const fileName: string = StringUtils.sanitizeFileName(this.projectService.getProjectName(this.projectModel.currentProject));
          FileUtils.saveBinaryFile(fileName, data, '.wsp');
        });
      })
      .catch(error => {
        this.alertHelper.showError('exportProject.title.export_failed', 'exportProject.message.export_failed');
      });
  }
}
